import { Grid, xcss } from '@atlaskit/primitives';
import React from 'react';

const fillResponsiveGridStyles = xcss({
	gridTemplateColumns: 'repeat(auto-fit, minmax(252px, 1fr))',
	gap: 'space.200',
});

const responsiveGridStyles = xcss({
	gridTemplateColumns: 'repeat(auto-fill, minmax(252px, 1fr))',
	gap: 'space.200',
});

interface Props {
	children: React.ReactNode;
	fillAvailableSpace?: boolean;
}

export const AppsGrid = ({ children, fillAvailableSpace = false }: Props) => {
	return <Grid xcss={fillAvailableSpace ? fillResponsiveGridStyles : responsiveGridStyles}>{children}</Grid>;
};
